import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {PinIcon} from '@primer/octicons-react'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {PinnedEventNode} from './issue-viewer-view-query-types'
import {TimelineRow} from './row/TimelineRow'

// RELAY-CLEANUP(PinnedEvent): widens nullable fields so still-Relay parent data is assignable.
// Remove when IssueTimelineItem leaves Relay.
export type PinnedEventFragment = RelayCompat<Pick<PinnedEventNode, 'actor' | 'createdAt' | 'databaseId'>>

type PinnedEventProps = {
  queryRef: PinnedEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function PinnedEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: PinnedEventProps): React.ReactElement {
  const {actor, createdAt, databaseId} = queryRef
  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={PinIcon}
    >
      <TimelineRow.Main>{`${LABELS.timeline.pinned} `}</TimelineRow.Main>
    </TimelineRow>
  )
}
